import { Link } from '@tanstack/react-router'
import { useTheme } from 'next-themes'
import { Moon, Sun } from 'lucide-react'
import { useEffect, useState } from 'react'
import { PREVIEW_APP_URL, GITHUB_REPO_URL } from '@/lib/constants'

export function Navbar() {
  const { setTheme, resolvedTheme } = useTheme()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  const isDark = resolvedTheme === 'dark'

  return (
    <nav className="sticky top-0 z-50 w-full border-b border-black/10 bg-white/80 backdrop-blur-xl dark:border-white/10 dark:bg-[#0A0A0B]/80">
      <div className="mx-auto flex h-16 max-w-[1152px] items-center justify-between px-6">
        {/* Logo */}
        <Link
          to="/"
          className="font-mono text-lg font-semibold tracking-tight text-gray-900 transition-colors hover:text-[#448AFF] dark:text-white dark:hover:text-[#448AFF]"
        >
          Garmisch
        </Link>

        {/* Navigation Links */}
        <div className="flex items-center gap-8">
          <Link
            to="/"
            className="text-sm font-medium text-gray-600 transition-colors hover:text-gray-900 dark:text-white/70 dark:hover:text-white"
          >
            Home
          </Link>
          <a
            href={PREVIEW_APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-medium text-gray-600 transition-colors hover:text-gray-900 dark:text-white/70 dark:hover:text-white"
          >
            Components
          </a>
          <a
            href={GITHUB_REPO_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-medium text-gray-600 transition-colors hover:text-gray-900 dark:text-white/70 dark:hover:text-white"
          >
            GitHub
          </a>
          <Link
            to="/privacy"
            className="text-sm font-medium text-gray-600 transition-colors hover:text-gray-900 dark:text-white/70 dark:hover:text-white"
          >
            Privacy
          </Link>
          <Link
            to="/terms"
            className="text-sm font-medium text-gray-600 transition-colors hover:text-gray-900 dark:text-white/70 dark:hover:text-white"
          >
            Terms
          </Link>

          {/* Theme Toggle */}
          <button
            onClick={() => setTheme(isDark ? 'light' : 'dark')}
            className="rounded-lg p-2 text-gray-600 transition-colors hover:bg-black/5 hover:text-gray-900 dark:text-white/70 dark:hover:bg-white/5 dark:hover:text-white"
            aria-label="Toggle theme"
          >
            {mounted &&
              (isDark ? (
                <Sun className="h-4 w-4" />
              ) : (
                <Moon className="h-4 w-4" />
              ))}
          </button>

          {/* CTA Button */}
          <a
            href={PREVIEW_APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-xl bg-[#448AFF] px-4 py-2 text-sm font-semibold text-white transition-all hover:bg-[#448AFF]/90 hover:shadow-lg hover:shadow-[#448AFF]/20"
          >
            View Components
          </a>
        </div>
      </div>
    </nav>
  )
}
